import { apiSlice } from 'src/features/api/api-slice';
import { ApiResponse } from 'src/common/interfaces';
import { RTKQueryTag } from 'src/common/constants';

import { PersonalBadgeData, PersonalBadgeParams } from './personal-badges.types';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBadgeByUserAndBadgeName: builder.query<ApiResponse<PersonalBadgeData>, PersonalBadgeParams>({
      query: ({ username, badgeName }: PersonalBadgeParams) => ({
        method: 'GET',
        url: `/users/${username}/badges/${badgeName}`,
      }),
      providesTags: (result, error, { username, badgeName }) => [
        { type: RTKQueryTag.PersonalBadges, id: `${username}-${badgeName}` },
      ],
    }),
  }),
});

// Export the hook for this query
export const { useGetBadgeByUserAndBadgeNameQuery } = extendedApiSlice;
